import React, { useState, useEffect } from 'react'
import styles from "./styles.module.css";
import { connect } from 'react-redux';
import Loader from 'react-loader'

import { getUniversity } from '../../../actions/report';

import BtnBack from '../helper/btnBack/BtnBack';
import GetHeader from '../helper/getHeader/GetHeader';

import bg from '../../../assets/dashboard/background_1.png'
import logo_big from '../../../assets/dashboard/logo_big.png'
import { BACKEND_URL_PREFIX } from '../../../utils/const';
import { store } from '../../App';
import { signOut } from '../../../actions/auth';

const mainPPSList = [
  { label: 'военнослужащие', value: 'military' },
  { label: 'профессоров', value: 'professor' },
  { label: 'гражданский персонал', value: 'citizen' },
  { label: 'доцентов', value: 'docent' },
  { label: 'докторов наук', value: 'doctor' },
  { label: 'укомплектованность ппс учеными', value: 'staffing_scientists' },
  { label: 'кандидатов наук', value: 'candidate' }
]


const docAdStaffList = [
  { label: 'докторантура', value: 'doctor' },
  { label: 'очная адъюнктура', value: 'fulltime_adjuncture' },
]

const avgGiaMarkList = [
  { label: 'Государственный междисциплинарный экзамен', value: 'gos_interdisc_exam' },
  { label: 'Защита ВКР', value: 'vkr' },
  { label: 'Государственный экзамен по физической подготовке', value: 'gos_fiz' }
]

const monthList = [
  { en: 'sep', ru: 'сен', num: 9 },
  { en: 'oct', ru: 'окт', num: 10 },
  { en: 'nov', ru: 'нов', num: 11 },
  { en: 'decb', ru: 'дек', num: 12 },
  { en: 'jan', ru: 'янв', num: 1 },
  { en: 'feb', ru: 'фев', num: 2 },
  { en: 'mar', ru: 'мар', num: 3 },
  { en: 'apr', ru: 'апр', num: 4 },
  { en: 'may', ru: 'май', num: 5 },
  { en: 'jun', ru: 'июн', num: 6 },
  { en: 'jul', ru: 'июл', num: 7 },
  { en: 'aug', ru: 'авг', num: 8 }
]

function PersonalMain({
  university,
  getUniversity,
  match,
  ...props
}) {

  const [uni, setUni] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const { id } = match.params
  const dispatch = store.dispatch;
  const history = props?.history
  const { main_pps_stat, doc_ad_staffing, mark_stat, avg_gia_mark } = data || {}

  useEffect(() => {
    setLoading(true)
    university && university.length > 0 && id != 'all' && getUniversity();
  }, []);

  useEffect(() => {
    if (university && university.length > 0 && id != null && id != 'all') {
      const [one, two] = id.split('_');
      const univer = two ? university[one].branches[two] : university[one]
      const prefix = univer?.api_url
      if (prefix?.length > 1) {
        const url = `${prefix}dashboard/university_stat`
        fetch(url)
          .then(resp => resp.json())
          .then(data => setResponseData(data))
      }
      setUni(univer)
    }
    if (id == 'all' && university && university.length > 0) {
      const url = `${BACKEND_URL_PREFIX}/dashboard/university_stat`
      fetch(url)
        .then(resp => resp.json())
        .then(data => setResponseData(data))
    }
  }, [university]);

  const setResponseData = (data) => {
    setData(data)
    setLoading(false)
  }


  const renderMainPPSStat = () => {

    const firstULlist = mainPPSList.filter((_, ind) => ind % 2 === 0)
    const secondULlist = mainPPSList.filter((_, ind) => ind % 2 === 1)

    const renderLi = ({ label, value }) => (
      <li>
        <span>{main_pps_stat[value]}%</span>
        {label}
      </li>
    )

    return (
      <div className={styles.firstMain}>
        <ul>{firstULlist.map(renderLi)}</ul>
        <ul>{secondULlist.map(renderLi)}</ul>
      </div>
    )
  }


  const renderDocAdStaff = () => {

    const renderLi = ({ label, value }) => (
      <li>
        <span>{doc_ad_staffing[value]}%</span>
        {label}
      </li>
    )

    return <ul>{docAdStaffList.map(renderLi)}</ul>
  }

  const getRusMonth = (month) => {
    return monthList.find(el => el.en == month.en)
  }
  const getRusMonth2 = (month) => {
    return monthList.find(el => el.num == month.value.month)
  }

  useEffect(() => {
    const someValue = store.getState().auth.access_modes?.['Режимы']?.['Показатели деятельности вуза']
    if (someValue != 'Полный' && id == 'all') {
      dispatch(signOut(history))
    }
  }, []);

  const renderMarkStat = () => {
    const ruMass = []
    Object.keys(mark_stat).forEach(function (key, index) {
      ruMass.push({ value: mark_stat[key], en: key });
    });
    return (
      <div className={styles.progressBlock}>
        <div className={styles.lineBLock}>
          {/* {[3.8, 4, 4.2, 4.4, 4.6, 4.8, 5].map(el => */}
          {[2, 2.5, 3, 3.5, 4, 4.5, 5].map(el =>
            <div className={styles.lineItem}>{el} <div className={styles.lineItemInner}></div></div>)}
        </div>
        {ruMass?.map((el) =>
          <div className={styles.progress}>
            <div className={styles.score} style={{ height: `${(300 / 14) + (el.value.grade - 2) * (300 / 3.5)}px` }}><span></span></div>
            {/* <div className={styles.score} style={{ height: `${280 / 5 * (el.value.grade || 0)}px` }}><span></span></div> */}
            {/* <div className={styles.month}>{getRusMonth(el)?.ru}</div> */}
            <div className={styles.month}>{getRusMonth2(el)?.ru}</div>
          </div>
        )
        }
      </div>
    )
  }


  const renderAvgGiaMark = () => {
    // const goodList = avgGiaMarkList.map(({ value }) => ({ key: value, value: avg_gia_mark[value] }))
    const mark = data.avg_gia_mark

    return (
      <div className={styles.avg_mark}>
        {mark &&
          <div className={styles.blocks}>
            <div className={styles.avg_markChartCylinderContainer}>
              {mark?.map((el, inx) => {
                const height = `${130 / mark?.map(el => el.avg_grade).sort((a, b) => b - a)[0] * el.avg_grade}px`

                return (


                  <div className={styles[`honors_degreeBlock_${inx}`]}>
                    <div className={styles.chartCylinder} style={{ height: height }}>
                      <div className={styles.perc}>{el.avg_grade}</div>
                    </div>
                    <span style={{ height: '80px' }}>{el.typename}</span>
                  </div>

                )
              })}
            </div>
          </div>
        }
      </div>
    )
  }

  return (
    <div className={styles.wrapper}>
      <img src={bg} className={styles.bg} />
      <div className={styles.logo_bigWrapper}>
        <img src={logo_big} className={styles.logo_big} />
      </div>
      <GetHeader title={<>ПОКАЗАТЕЛИ ДЕЯТЕЛЬНОСТИ {uni?.name}</>} />
      <Loader loaded={!loading} color="grey">

        {
          data &&
          <div className={styles.wrapperBlock}>

            <div className={styles.first}>
              <h4 className={styles.title}>КАЧЕСТВЕННАЯ ХАРАКТЕРИСТИКА ППС</h4>
              {renderMainPPSStat()}
            </div>

            <div className={styles.second}>
              <h4 className={styles.title}>УКОМПЛЕКТОВАННОСТЬ</h4>
              {renderDocAdStaff()}
            </div>

            <div className={styles.third}>
              <h4 className={styles.title}>ДИНАМИКА УСПЕВАЕМОСТИ ЗА ТЕКУЩИЙ УЧЕБНЫЙ ГОД (СРЕДНИЙ БАЛЛ)</h4>
              {renderMarkStat()}
            </div>

            <div className={styles.fourth}>
              <h4 className={styles.title}>СРЕДНИЙ БАЛЛ СДАЧИ ГОСУДАРСТВЕННЫХ АТТЕСТАЦИОННЫХ ИСПЫТАНИЙ ЗА УЧЕБНЫЙ ГОД</h4>
              {renderAvgGiaMark()}
            </div>

          </div>
        }

      </Loader>
      <BtnBack />
    </div>
  )
}

const mapStateToProps = ({ report: { university } }) => ({ university });

export default connect(mapStateToProps, { getUniversity })(PersonalMain);